import * as React from "react";
import type { SVGProps } from "react";
const SvgOrder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#order_svg__a)">
      <path d="M7 22a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v17a1 1 0 0 1-1 1" />
      <path d="M10 7a1 1 0 0 1-.71-.29L7 4.41l-2.29 2.3a1.004 1.004 0 0 1-1.42-1.42l3-3a1 1 0 0 1 1.42 0l3 3a1 1 0 0 1 0 1.42A1 1 0 0 1 10 7M17 21a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v17a1 1 0 0 1-1 1" />
      <path d="M17 22a1 1 0 0 1-.71-.29l-3-3a1.004 1.004 0 1 1 1.42-1.42l2.29 2.3 2.29-2.3a1.007 1.007 0 0 1 1.42 0 1.003 1.003 0 0 1 0 1.42l-3 3A1 1 0 0 1 17 22" />
    </g>
    <defs>
      <clipPath id="order_svg__a">
        <path fill="#fff" d="M3 2h18v20H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOrder;
